function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useMemo } from 'react';
import { ProductDetailPanel, PayCyclePanel, CycleRadio } from './styled';
import { Card, Title1, Title3, Title4, DescText } from '../../styled';
import { SLRadio } from '@yy/sl-admin-components';
import { useConfigAtom, useDataAtomValues, useStateAtomValues } from '../../state';
import { EServiceType } from '../../constants';
import { useEventAtom, EEvent } from '../../events';
import { useTranslation } from '../../_utils/i18n';
import { formatPriceJson, formatApiIntl } from '../../_utils/tool';
import { useSpaceJoiner, useComputedBuyNum } from '../../hooks';
import dayjs from 'dayjs';
import { Tooltip } from 'antd';
var ProductCrad = function ProductCrad() {
  var _skuInfo$items2, _skuInfo$items3, _productInfo$skus2;
  var _useConfigAtom = useConfigAtom(),
    _useConfigAtom2 = _slicedToArray(_useConfigAtom, 2),
    _useConfigAtom2$ = _useConfigAtom2[0],
    billId = _useConfigAtom2$.billId,
    skuId = _useConfigAtom2$.skuId,
    priceCurrencyCode = _useConfigAtom2$.priceCurrencyCode,
    bizProductInfo = _useConfigAtom2$.bizProductInfo,
    setConfigAtom = _useConfigAtom2[1];
  var _useDataAtomValues = useDataAtomValues(),
    billDetail = _useDataAtomValues.billDetail,
    productInfo = _useDataAtomValues.productInfo,
    nextSubInfo = _useDataAtomValues.nextSubInfo;
  var _useStateAtomValues = useStateAtomValues(),
    notCanPayUpgradeSubBill = _useStateAtomValues.notCanPayUpgradeSubBill;
  var _useEventAtom = useEventAtom(),
    event$ = _useEventAtom.event$;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    i18n = _useTranslation.i18n;
  var joiner = useSpaceJoiner();
  var computedBuyNum = useComputedBuyNum();

  // 商品展示的币种，若已下单则取下单时商品的币种快照
  var productCurrency = useMemo(function () {
    return (billDetail === null || billDetail === void 0 ? void 0 : billDetail.productCurrency) || priceCurrencyCode;
  }, [priceCurrencyCode, billDetail === null || billDetail === void 0 ? void 0 : billDetail.productCurrency]);
  var skuInfo = useMemo(function () {
    var _productInfo$skus;
    return productInfo === null || productInfo === void 0 ? void 0 : (_productInfo$skus = productInfo.skus) === null || _productInfo$skus === void 0 ? void 0 : _productInfo$skus.find(function (item) {
      return item.skuId === skuId;
    });
  }, [productInfo, skuId]);
  var productName = useMemo(function () {
    return bizProductInfo !== null && bizProductInfo !== void 0 && bizProductInfo.productName ? bizProductInfo === null || bizProductInfo === void 0 ? void 0 : bizProductInfo.productName : formatApiIntl(productInfo === null || productInfo === void 0 ? void 0 : productInfo.name);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bizProductInfo === null || bizProductInfo === void 0 ? void 0 : bizProductInfo.productName, productInfo === null || productInfo === void 0 ? void 0 : productInfo.name, i18n.language]);

  // 业务自定义商品价格
  var productAmount = Number.isFinite(bizProductInfo === null || bizProductInfo === void 0 ? void 0 : bizProductInfo.productAmount) ? bizProductInfo === null || bizProductInfo === void 0 ? void 0 : bizProductInfo.productAmount : undefined;
  var handleSkuChange = function handleSkuChange(e) {
    var value = e.target.value;
    event$ === null || event$ === void 0 ? void 0 : event$.emit({
      type: EEvent.ON_PERIOD_CHANGED,
      payload: {
        skuId: value
      }
    });
    setConfigAtom(function (draft) {
      draft.skuId = value;
    });
  };
  var isNeedSpace = useMemo(function () {
    if (i18n.language === 'zh-hans-cn' || i18n.language === 'zh-hant-tw') {
      return false;
    }
    return true;
  }, [i18n.language]);
  var periodInfo = useMemo(function () {
    var _skuInfo$items;
    var isPeriodExist = [nextSubInfo === null || nextSubInfo === void 0 ? void 0 : nextSubInfo.realDays, skuInfo === null || skuInfo === void 0 ? void 0 : skuInfo.cycleNum].every(function (item) {
      return !!item;
    });
    var space = isNeedSpace ? ' ' : '';
    var calculated = {
      // 周期
      cycle: '',
      // 有效期
      expirationDate: ''
    };

    // 是否配置了service list
    var isSkuInfoItemsExist = (skuInfo === null || skuInfo === void 0 ? void 0 : (_skuInfo$items = skuInfo.items) === null || _skuInfo$items === void 0 ? void 0 : _skuInfo$items.length) > 0;
    var prefix = isSkuInfoItemsExist ? ' / ' : '';

    // 商品的周期展示
    if (isPeriodExist && isSkuInfoItemsExist) {
      var modedPeriod = Math.floor((nextSubInfo === null || nextSubInfo === void 0 ? void 0 : nextSubInfo.realDays) / skuInfo.cycleNum);
      calculated.cycle = joiner(["".concat(prefix).concat(modedPeriod), t('settlement.periodType.day'), /*#__PURE__*/React.createElement(React.Fragment, null, " * ", skuInfo === null || skuInfo === void 0 ? void 0 : skuInfo.cycleNum), t('settlement.cyclenum1-2')], space);
    }

    // 订阅类商品下到期清零的服务,优先显示商品中设置的circlename, 对应原先的XX天*XX次
    if ((productInfo === null || productInfo === void 0 ? void 0 : productInfo.serviceType) === EServiceType.SUB && skuInfo !== null && skuInfo !== void 0 && skuInfo.cycleName) {
      calculated.cycle = joiner([prefix, formatApiIntl(skuInfo === null || skuInfo === void 0 ? void 0 : skuInfo.cycleName)], '');
    }
    return calculated;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t, skuInfo, isNeedSpace, productInfo === null || productInfo === void 0 ? void 0 : productInfo.serviceType, nextSubInfo === null || nextSubInfo === void 0 ? void 0 : nextSubInfo.realDays]);

  // 订阅类
  var isSub = (productInfo === null || productInfo === void 0 ? void 0 : productInfo.serviceType) === EServiceType.SUB;
  // 服务类
  var isService = (productInfo === null || productInfo === void 0 ? void 0 : productInfo.serviceType) === EServiceType.SERVICE;
  // 增值类
  var isIncrement = (productInfo === null || productInfo === void 0 ? void 0 : productInfo.serviceType) === EServiceType.INCREMENT;
  var title3Desc = skuInfo !== null && skuInfo !== void 0 && skuInfo.period ? /*#__PURE__*/React.createElement(DescText, {
    marginTop: "4px"
  }, t('settlement.product.period'), "\uFF1A", notCanPayUpgradeSubBill ? t('settlement.upgrade.note1') : /*#__PURE__*/React.createElement(React.Fragment, null, (nextSubInfo === null || nextSubInfo === void 0 ? void 0 : nextSubInfo.startTime) && dayjs(nextSubInfo.startTime).format('YYYY-MM-DD'), " -", ' ', (nextSubInfo === null || nextSubInfo === void 0 ? void 0 : nextSubInfo.endTime) && dayjs(nextSubInfo.endTime).format('YYYY-MM-DD'), isSub && (productInfo === null || productInfo === void 0 ? void 0 : productInfo.isTranTrial) && /*#__PURE__*/React.createElement("span", {
    className: "tip--remaindays"
  }, "(", t('packageSet.index.payMethod.section.app.admin.note2'), ")"))) : null;
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Title3, null, t('settlement.purchase item')), /*#__PURE__*/React.createElement(ProductDetailPanel, null, /*#__PURE__*/React.createElement("div", {
    className: "leftInfo"
  }, /*#__PURE__*/React.createElement(Title3, null, productName), skuInfo !== null && skuInfo !== void 0 && (_skuInfo$items2 = skuInfo.items) !== null && _skuInfo$items2 !== void 0 && _skuInfo$items2.length || periodInfo.cycle ? /*#__PURE__*/React.createElement(DescText, {
    marginTop: productName ? '4px' : 0
  }, skuInfo === null || skuInfo === void 0 ? void 0 : (_skuInfo$items3 = skuInfo.items) === null || _skuInfo$items3 === void 0 ? void 0 : _skuInfo$items3.map(function (item, index) {
    return /*#__PURE__*/React.createElement("span", {
      key: item.serviceKey
    }, index ? /*#__PURE__*/React.createElement(React.Fragment, null, " \u2022 ") : null, formatApiIntl(item.serviceName), isSub && joiner([/*#__PURE__*/React.createElement(React.Fragment, null, isNeedSpace && item.quantity ? /*#__PURE__*/React.createElement(React.Fragment, null, " * ") : '*', item.quantity), formatApiIntl(item.unit)], isNeedSpace && item.unit ? ' ' : ''), isService && joiner([/*#__PURE__*/React.createElement(React.Fragment, null, t('subscriptions.packagePay.num'), "\uFF1A", item.quantity * computedBuyNum), formatApiIntl(item.unit)], isNeedSpace && item.unit ? ' ' : ''));
  }), periodInfo.cycle) : null, title3Desc), /*#__PURE__*/React.createElement(Title1, null, formatPriceJson(productAmount || (skuInfo === null || skuInfo === void 0 ? void 0 : skuInfo.price), productCurrency, i18n.language, computedBuyNum))), isSub || isIncrement ? /*#__PURE__*/React.createElement(PayCyclePanel, null, /*#__PURE__*/React.createElement(Title4, null, t('settlement.paymentcycle')), /*#__PURE__*/React.createElement(SLRadio.Group, {
    value: skuId,
    onChange: handleSkuChange,
    disabled: !!billId
  }, productInfo === null || productInfo === void 0 ? void 0 : (_productInfo$skus2 = productInfo.skus) === null || _productInfo$skus2 === void 0 ? void 0 : _productInfo$skus2.map(function (item) {
    if (item.purchasable) {
      return /*#__PURE__*/React.createElement(CycleRadio, {
        value: item.skuId,
        key: item.skuId,
        disabled: item.disabled || !item.purchasable
      }, formatApiIntl(item.durationTypeName) || item.durationType, "\uFF1A", formatPriceJson(productAmount || item.price, productCurrency, i18n.language));
    } else {
      return /*#__PURE__*/React.createElement(Tooltip, {
        title: t('settlement.purchase.disabled.tips')
      }, /*#__PURE__*/React.createElement(CycleRadio, {
        value: item.skuId,
        key: item.skuId,
        disabled: item.disabled || !item.purchasable
      }, formatApiIntl(item.durationTypeName) || item.durationType, "\uFF1A", formatPriceJson(productAmount || item.price, productCurrency, i18n.language)));
    }
  }))) : null);
};
export default ProductCrad;